import React, { useEffect, useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { apiClient } from "@/lib/auth";
import { fmtDateTime } from "@/lib/residentApi";

export function MigrationReport() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  useEffect(() => { if (open && !data) apiClient.get("/access/migration").then((r) => setData(r.data)).catch(() => setData({ rows: [] })); }, [open, data]);
  return (
    <div data-testid="am-migration" className="border-t border-white/10 pt-3">
      <button type="button" onClick={() => setOpen(!open)} data-testid="am-migration-toggle" className="flex items-center gap-2 font-mono text-[9px] tracking-[0.22em] uppercase text-nex-muted hover:text-nex-silver">
        {open ? <ChevronDown className="w-3.5 h-3.5" /> : <ChevronRight className="w-3.5 h-3.5" />}Migration report
      </button>
      {open && data && (
        <div className="mt-2 space-y-2 text-xs">
          <div className="text-nex-muted">{data.at ? `Applied ${fmtDateTime(data.at)}.` : "Not run yet."} Everyone kept the cards they saw before. Cards became Edit only where they hold a matching action permission, otherwise Read only.</div>
          <div className="overflow-x-auto border border-white/10 rounded-sm">
            <table className="w-full min-w-[520px]"><thead><tr className="text-left font-mono text-[9px] uppercase tracking-[0.18em] text-nex-muted">
              <th className="px-2 py-1.5">Person</th><th className="px-2 py-1.5">Before</th><th className="px-2 py-1.5">Edit</th><th className="px-2 py-1.5">Read only</th><th className="px-2 py-1.5">Lost</th></tr></thead>
              <tbody className="divide-y divide-white/5">{(data.rows || []).map((r) => (
                <tr key={r.user_id} data-testid={`am-migration-row-${r.user_id}`} className="text-nex-silver">
                  <td className="px-2 py-1.5">{r.name} <span className="text-nex-muted">({r.kind})</span></td>
                  <td className="px-2 py-1.5">{typeof r.old_visible === "string" ? r.old_visible : `${r.old_visible.length} cards`}</td>
                  <td className="px-2 py-1.5 text-emerald-300">{r.edit.length}</td><td className="px-2 py-1.5 text-sky-300">{r.view.length}</td>
                  <td className={`px-2 py-1.5 ${r.lost.length ? "text-red-300" : "text-nex-muted"}`}>{r.lost.length ? r.lost.join(", ") : "none"}</td>
                </tr>))}</tbody></table>
          </div>
        </div>
      )}
    </div>
  );
}

export function MyAccess() {
  const [data, setData] = useState(null);
  useEffect(() => { apiClient.get("/access/me").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data?.card_access) return null;
  const rows = Object.entries(data.card_access).sort();
  return (
    <div data-testid="my-access" className="max-w-md mx-auto mt-4 text-left text-xs border border-white/10 rounded-sm p-3">
      <div className="font-mono text-[9px] tracking-[0.22em] uppercase text-nex-muted mb-2">Your access</div>
      <ul className="space-y-1">{rows.map(([id, lv]) => <li key={id} className="flex justify-between gap-3 text-nex-silver"><span className="truncate">{data.cards[id] || id}</span><span className={lv === "edit" ? "text-emerald-300" : "text-sky-300"}>{lv === "edit" ? "Can edit" : "Read only"}</span></li>)}</ul>
    </div>
  );
}
